import React from 'react';
import * as Styled from "./style";

const TextIconButton = ({ disabled, actionClick, bgd, btnText, icon, tooltip }) => {
    return(
        <Styled.Button text_icon_button disabled={disabled} type="button" name="button" onClick={actionClick} className={bgd} title={tooltip}>{btnText}&nbsp;{icon}</Styled.Button>
    )
}

export default TextIconButton;